import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=0c31d49a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c31d49a')) {
      api.createRecord('0c31d49a', component.options)
    } else {
      api.reload('0c31d49a', component.options)
    }
    module.hot.accept("./FileIcon.vue?vue&type=template&id=0c31d49a", function () {
      api.rerender('0c31d49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/FileIcon.vue"
export default component.exports